
enum HouseValuationPageStates {
    INPUT = "inputState",
    RESULT = "resultState",
    LOADING = "loadingState"
}

export default HouseValuationPageStates
